/** Debajo funciones standalone */
// https://gist.github.com/nmsdvid/8807205
export function debounce(a,b,c){var d;return function(){var e=this,f=arguments;clearTimeout(d),d=setTimeout(function(){d=null,c||a.apply(e,f)},b),c&&!d&&a.apply(e,f)}}

export function setCookie(name, value, days) {
    var expires = '';
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '')  + expires + '; path=/';
}

export function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

export function eraseCookie(name) {   
    document.cookie = name+'=; Max-Age=-99999999;path=/;';  
}

export function injectScript(src, type) {

    window._injectedScripts = window._injectedScripts || [];
    
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        if (type) {
            script.type = type;
        }
        script.addEventListener('load', (e) => {
            window._injectedScripts.push(src);
            resolve(e);
        });
        script.addEventListener('error', e => reject(e.error));
        document.body.appendChild(script);
    });
}

export function injectScriptOnce(src, type) {
    window._injectedScripts = window._injectedScripts || [];

    if (window._injectedScripts.indexOf(src) > -1) {
        return new Promise((resolve, reject) => {
            resolve();
        });
    }
    
    return injectScript(src, type);
}

export function linearConversion(OldValue, OldMin, OldMax, NewMin, NewMax) {
    return (((OldValue - OldMin) * (NewMax - NewMin)) / (OldMax - OldMin)) + NewMin;
}

export function awaitTimeout(delay) {
    return new Promise(resolve => setTimeout(resolve, delay));
}

export function getWindowScrollTop() {
    var doc = document.documentElement;
    return (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
}

export function getWindowWidth() {
    return window.innerWidth;
}

export function initSingleModule(elm, moduleName) {
    moduleName = moduleName || elm.getAttribute('kd-module');
    let moduleFn = window.modules[moduleName] || window[moduleName];
    let module = new moduleFn(elm);
    elm.setAttribute('kd-initted', true);
    elm.kdModule = module;

    elm.dispatchEvent(new CustomEvent('kdinit'));
   
    return module;
}

window.initSingleModule = initSingleModule;


export function preloadUrl(url) {
    var req = new XMLHttpRequest();
    req.open('GET', url, true);
    req.responseType = 'blob';
    req.send();

    // req.onload = function() {
    //     console.log('loaded');
    // // Onload is triggered even on 404
    // // so we need to check the status code
    // if (this.status === 200) {
    //     var videoBlob = this.response;
    //     var vid = URL.createObjectURL(videoBlob); // IE10+
    //     // Video is now downloaded
    //     // and we can set it as source on the video element
    //     video.src = vid;
    // }
    // }
    // req.onerror = function() {
    // // Error
    // }
}

export function equalizeHeightByOffset(elements, options) {

	options = Object.assign({
        property: 'minHeight',
        margin: 0,
    }, options);

	var heightByOffsetTop = {};

    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

	function equalize() {
        setCss(elements, {
            [options.property]: ''
        });

        elements.forEach(element => {
            let offsetTop = element.getBoundingClientRect().top;
            let height 	  = element.getBoundingClientRect().height;

            if (options.property === 'minHeight') {
                heightByOffsetTop[offsetTop] = heightByOffsetTop[offsetTop] || 0;
                heightByOffsetTop[offsetTop] = Math.max(heightByOffsetTop[offsetTop], height);
            } else { // min
                heightByOffsetTop[offsetTop] = heightByOffsetTop[offsetTop] || Number.MAX_SAFE_INTEGER;
                heightByOffsetTop[offsetTop] = Math.min(heightByOffsetTop[offsetTop], height);
            }
        });

		for (let offsetTop in heightByOffsetTop) {
			var height = heightByOffsetTop[offsetTop];

            let filtered = []
            elements.forEach(element => {
                let diff = Math.abs(parseInt(element.getBoundingClientRect().top, 10) - parseInt(offsetTop, 10));

                if (diff <= options.margin) {
                    filtered.push(element);
                }
            });

            filtered.forEach(element => {
                setCss(element, {
                    [options.property]: height + 'px'
                });
            });
	
		}
	}

    window.addEventListener('resize', debounce(equalize, 100));
    setTimeout(equalize, 10);

};

export function setCss(elements, styles) {

    if (elements instanceof Element) {
        elements = [elements];
    } else if (typeof elements === 'string') {
        elements = document.querySelector(elements);
    }

    elements.forEach(element => {
        for (let property in styles) {
            element.style[property] = styles[property];
        }
    })
}